import { Box, Container, Stack, Typography } from "@mui/material";
import { ReactComponent as PoolLocationIcon } from "../../assets/pool-location.svg";
import { useState } from "react";
import { NavigartionDropdownMUI } from "./NavDropdown";
import useResponsive from "../../hooks/useResponsive";
import { Link } from "react-router-dom";

export const HeaderNavigation = () => {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const { isMd, isLg, isXl } = useResponsive();

  const handleOpen = (dropdown: string) => {
    setOpenDropdown(dropdown);
  };

  const handleClose = () => {
    setOpenDropdown(null);
  };

  const isDesktop = isMd || isLg || isXl;

  return (
    <Box sx={{ background: "#ffd200", position: "sticky", top: 0, zIndex: 10 }}>
      <Container>
        <Stack
          flexDirection={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          gap={4}
          p={1.5}
        >
          {process.env.REACT_APP_ENVIRONMENT === "staging" ? (
            <Box
              fontWeight={"bold"}
              width={"200px"}
              sx={{ backgroundColor: "#000" }}
            >
              <Typography textAlign={"center"} fontSize={24} color={"#fff"}>
                STAGING
              </Typography>
            </Box>
          ) : (
            <Box />
          )}
          <Stack
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"flex-end"}
            gap={4}
          >
            {isDesktop ? (
              <>
                <Typography fontSize={12}>Dealer Login</Typography>
                <Typography fontSize={12}>1300 2 DAVEY</Typography>
              </>
            ) : (
              <Box mr={4}>
                <Typography fontSize={12}>Australia</Typography>
              </Box>
            )}
          </Stack>
        </Stack>
      </Container>
      <Box
        sx={{
          background: "#000000",
          height: "87px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Container>
          <Box
            marginX={4}
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            // onClick={() => setStep(1)}
            sx={{ cursor: "pointer" }}
            justifyContent={"space-between"}
          >
            <Link to={"https://daveywater.com/"}>
              <img
                decoding="async"
                width={isDesktop ? "224" : "112"}
                height={isDesktop ? "63" : "35"}
                alt="Davey Water Logo"
                src="https://daveywater.com/au/wp-content/uploads/sites/2/2022/11/davey-logo-01.png"
                sizes="(max-width: 900px) 100vw, 224px"
              />
            </Link>
            {isDesktop && (
              <Stack flexDirection={"row"}>
                <NavigartionDropdownMUI
                  items={[
                    {
                      label: "Home & Garden",
                      path: "https://daveywater.com/au/water-solutions/home-garden/",
                    },

                    {
                      label: "Farm & Irrigation",
                      path: "https://daveywater.com/au/water-solutions/farm-irrigation/",
                    },
                    {
                      label: "Pool & Spa",
                      path: "https://daveywater.com/au/water-solutions/pool-spa/",
                    },
                    {
                      label: "Treatment & Filtration",
                      path: "https://daveywater.com/au/water-solutions/water-treatment/",
                    },
                    {
                      label: "Commercial Pumps",
                      path: "https://daveywater.com/au/water-solutions/commercial/",
                    },
                  ]}
                  selected="Water Solutions"
                  Icon={PoolLocationIcon}
                  isOpen={openDropdown === "Water Solutions"}
                  onOpen={() => handleOpen("Water Solutions")}
                  onClose={handleClose}
                />
                <NavigartionDropdownMUI
                  items={[
                    {
                      label: "All Products",
                      path: "https://daveywater.com/au/products/",
                    },
                    {
                      label: "Pumps",
                      path: "https://daveywater.com/au/products/pumps/",
                    },
                    {
                      label: "FireFighers",
                      path: "https://daveywater.com/au/products/firefighter/",
                    },
                    {
                      label: "Pressure Tanks",
                      path: "https://daveywater.com/au/products/pressure-tanks",
                    },
                    {
                      label: "Pool Pumps & Filters",
                      path: "https://daveywater.com/au/products/pool-pumps-filters",
                    },
                    {
                      label: "Chlorinators",
                      path: "https://daveywater.com/au/products/chlorinators",
                    },
                    {
                      label: "Pool & Spa Heaters",
                      path: "https://daveywater.com/au/products/pool-spa-heaters",
                    },
                    {
                      label: "Accessories",
                      path: "https://daveywater.com/au/products/accessories",
                    },
                  ]}
                  selected="Products"
                  Icon={PoolLocationIcon}
                  isOpen={openDropdown === "Products"}
                  onOpen={() => handleOpen("Products")}
                  onClose={handleClose}
                />
                <NavigartionDropdownMUI
                  items={[
                    {
                      label: "About us",
                      path: "https://daveywater.com/au/about-us",
                    },
                    {
                      label: "Case studies",
                      path: "https://daveywater.com/au/category/case-studies/",
                    },
                    {
                      label: "News & Community",
                      path: "https://daveywater.com/au/category/news-community/",
                    },
                    {
                      label: "Careers at Davey",
                      path: "https://daveywater.com/au/about-us/careers/",
                    },
                    {
                      label: "Master Dealers Spotlight",
                      path: "https://daveywater.com/au/about-us/master-dealers/",
                    },
                    {
                      label: "Firefighter Pre-Season Campaign",
                      path: "https://daveywater.com/au/about-us/firefighter-pre-season-campaign/",
                    },
                    {
                      label: "Davey at Home",
                      path: "https://daveywater.com/au/davey-at-home/",
                    },
                  ]}
                  selected="About Davey"
                  Icon={PoolLocationIcon}
                  isOpen={openDropdown === "About Davey"}
                  onOpen={() => handleOpen("About Davey")}
                  onClose={handleClose}
                />
                <NavigartionDropdownMUI
                  items={[
                    {
                      label: "Select the right pump",
                      path: "https://daveywater.com/au/support/domestic-pump-sizing/",
                    },
                    {
                      label: "Commercial E-tools",
                      path: "https://productselector.davey.com.au/login.aspx?ReturnUrl=%2fStartMain.aspx",
                    },
                    {
                      label: "Product Resourses",
                      path: "https://daveywater.com/au/support/product-resources/",
                    },
                    {
                      label: "Warrenty Information",
                      path: "https://daveywater.com/au/support/product-warranty/",
                    },
                    {
                      label: "Product Recall and Safety",
                      path: "https://daveywater.com/au/product-recall-and-safety/",
                    },
                    {
                      label: "Davey learning",
                      path: "https://daveywater.com/au/litmos-coming-soon/",
                    },
                    {
                      label: "Account enquiry",
                      path: "https://daveywater.com/au/support/account-enquiry/",
                    },
                    {
                      label: "Contact us",
                      path: "https://daveywater.com/au/support/contact-us/",
                    },
                  ]}
                  selected="Support"
                  Icon={PoolLocationIcon}
                  isOpen={openDropdown === "Support"}
                  onOpen={() => handleOpen("Support")}
                  onClose={handleClose}
                />
              </Stack>
            )}
          </Box>
        </Container>
      </Box>
    </Box>
  );
};
